var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 0.875H1.40625C0.632438 0.875 0 1.50466 0 2.28125V10.7188C0 11.4956 0.632844 12.125 1.40625 12.125H14.5938C15.3676 12.125 16 11.4953 16 10.7188V2.28125C16 1.50447 15.3673 0.875 14.5938 0.875ZM14.3778 1.8125C13.9232 2.26866 8.58266 7.62656 8.36325 7.84669C8.18 8.0305 7.82009 8.03062 7.63675 7.84669L1.62219 1.8125H14.3778ZM0.9375 10.5464V2.45359L4.97078 6.5L0.9375 10.5464ZM1.62219 11.1875L5.63263 7.164L6.97278 8.50853C7.52197 9.0595 8.47825 9.05928 9.02725 8.50853L10.3674 7.16403L14.3778 11.1875H1.62219ZM15.0625 10.5464L11.0292 6.5L15.0625 2.45359V10.5464Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.e9a98cfc1d8badcb8bcf9edc9ecae3f4.svg";
export { ForwardRef as ReactComponent };